import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SCORMAdapter } from 'src/app/scorm/scorm-adapter';
import { ScormCrossWindowService } from 'src/app/services/scorm-cross-window.service';

@Component({
    selector: 'app-scorm-player',
    templateUrl: './scorm-player.component.html',
    styleUrl: './scorm-player.component.scss',
    standalone: false
})
export class ScormPlayerComponent  implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private httpClient: HttpClient,
    private scormCrossWindowService: ScormCrossWindowService
  ) {}

  ngOnInit() {
    const courseTemplateId = this.route.snapshot.paramMap.get('courseTemplateId')!;
    const personId = this.route.snapshot.queryParamMap.get('personId')!;
    const personName = this.route.snapshot.queryParamMap.get('personName')!;

    const scormAdapter = new SCORMAdapter(
      this.httpClient,
      courseTemplateId
    );

    scormAdapter.runScormPlayer(personId, personName);

    scormAdapter.isFinished$.subscribe(() => {
      this.scormCrossWindowService.finish();
    });

    window.addEventListener('beforeunload', () => {
      this.scormCrossWindowService.finish();
    });
  }
}
